module.exports = __webpack_public_path__ + "img/icon-white-6.cc8f882e.svg";